<template>
    <modal v-model="showModal" :portal="sidebar">
        <template #title>
            <span>{{ trans('client.journal_print') }}</span>
        </template>

        <form @submit.prevent="print">
            <!-- Orientation -->
            <div class="form-group mt-4">
                <label class="capitalize">Orientation</label>
                <div class="radio mt-0">
                    <input type="radio" name="orientation" id="orientation-portrait" value="portrait" v-model="form.orientation">
                    <label for="orientation-portrait">
                        {{ trans('client.portrait') }}
                    </label>
                </div>
                <div class="radio">
                    <input type="radio" name="orientation" id="orientation-landscape" value="landscape" v-model="form.orientation">
                    <label for="orientation-landscape">
                        {{ trans('client.landscape') }}
                    </label>
                </div>
            </div>

            <div class="row mt-4" v-if="isTreatmentsActive && treatments.length > 0">
                <div class="col-xs-12 col-sm-8">
                    <treatment-selector
                        :treatments="treatments"
                        v-model="form.treatmentId"
                        :show-appointments="false">
                    </treatment-selector>
                </div>
            </div>

            <ep-button
                class="m-t-15 pull-right"
                type="submit"
                start-icon="print"
            >
                {{ trans('invoice.print') }}
            </ep-button>
            <div class="clearfix"></div>
        </form>
    </modal>
</template>

<script>
import Apps from '@/core/Apps';
import Modal from 'Components/global/Modal.vue';
import EpButton from '@/system/components/global/button';
import printJournalsMixin from '@/system/helpers/journalPrintToPdf';
import TreatmentSelector from 'Components/apps/treatments/TreatmentSelector.vue';

export default {
    components: {
        TreatmentSelector,
        Modal,
        EpButton,
    },

    mixins: [printJournalsMixin],

    props: {
        clientOrGroup: {
            type: Object,
            required: true,
        },

        sidebar: {
            type: Boolean,
            default: false,
        },

        filters: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            showModal: false,
            form: {
                orientation: 'portrait',
                treatmentId: null,
            },
        }
    },

    created() {
        if (this.isTreatmentsActive) {
            this.$store.dispatch('clientTreatments/loadTreatments', this.clientId)
        }
    },

    mounted() {
        this.showModal = true
    },

    methods: {
        print() {
            this.convertJournalsToPdfAndPrint(
                0,
                'journal',
                this.form.orientation,
                this.form.treatmentId,
                this.filters,
            );
            this.showModal = false
            this.$nextTick(() => this.$emit('printed'))
        },
    },

    computed: {
        isTreatmentsActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.Treatments)
        },
        treatments() {
            return this.$store.getters['clientTreatments/all']
        },
    },
}
</script>
